var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReservationServing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5271_1411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.30328 4.96474V3.44025H7.79359V4.96474C6.26316 5.13315 4.83651 5.80634 3.74754 6.87396C2.65857 7.94158 1.97191 9.34026 1.80013 10.8407H1V12.3208H16.0969V10.8407H15.2967C15.125 9.34026 14.4383 7.94158 13.3493 6.87396C12.2604 5.80634 10.8337 5.13315 9.30328 4.96474Z",
    fill: "#FF8C21"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5271_1411"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9849,
    height: 15.9849,
    fill: "white",
    transform: "translate(0 0.440254)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservationServing);
export default __webpack_public_path__ + "static/media/reservation-serving.6954971213cd2ea2dda72a24f7a80980.svg";
export { ForwardRef as ReactComponent };